// @flow strict

import * as React from 'react';
import cx from 'classnames';
import TextInput from '../TextInput';
import { Button } from '../Button';
import styles from './styles.scss';

type PropType = {|
  formId?: string,
  placeholder: string,
  fieldName?: string,
  action: string,
  searchTerm?: string,
  className?: string,
  background?: 'Default' | 'Dark',
|};

type RefType = { current: null | HTMLFormElement } | ((null | HTMLFormElement) => mixed);

const Search = React.forwardRef<PropType, HTMLFormElement>((props: PropType, ref: RefType) => {
  return (
    <form
      className={cx(styles.container, props.className)}
      method="get"
      action={props.action}
      id={props.formId}
      ref={ref}
    >
      <TextInput
        aria-label="Search"
        name={props.fieldName || 'q'}
        defaultValue={props.searchTerm}
        className={styles.textField}
        type="Search"
        placeholder={props.placeholder}
        background={props.background || 'Default'}
        required
      />
      <Button type="submit" size="Small" onClick={() => {}}>
        Search
      </Button>
    </form>
  );
});

export default Search;
